import { render, staticRenderFns } from "./examination_room_details.vue?vue&type=template&id=0c85c368&scoped=true&"
import script from "./examination_room_details.vue?vue&type=script&lang=js&"
export * from "./examination_room_details.vue?vue&type=script&lang=js&"
import style0 from "./examination_room_details.vue?vue&type=style&index=0&id=0c85c368&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85c368",
  null
  
)

export default component.exports